import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue';

import { BaseText, ButtonTertiary } from '@warrenbrasil/nebraska-web';
import { AppliedChart, AppliedTable } from './components';
import { AllocationLoader } from '@/modules/wealth/components/AllocationLoader';

import {
  getAppliedAllocation,
  IAppliedAllocation
} from '@/modules/wealth/services/portfolio-allocation';

interface Props {
  portfolioId: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppliedAllocation',
  props: {
    portfolioId: null
  },
  setup(__props: any) {

const { portfolioId } = __props as {
  portfolioId: string;
};



const appliedAllocation = ref<IAppliedAllocation>();
const isLoading = ref(true);
const hasError = ref(false);

const appliedChart = computed(() => {
  return appliedAllocation.value!.chart;
});

const appliedTable = computed(() => {
  return appliedAllocation.value!.items;
});

async function fetchAppliedAllocation() {
  hasError.value = false;
  isLoading.value = true;

  try {
    appliedAllocation.value = await getAppliedAllocation(portfolioId);
  } catch {
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
}

onMounted(() => {
  fetchAppliedAllocation();
});

return { __sfc: true,appliedAllocation, isLoading, hasError, appliedChart, appliedTable, fetchAppliedAllocation, BaseText, ButtonTertiary, AppliedChart, AppliedTable, AllocationLoader }
}

})